module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2022_06.f5eb3b6a.jpg";